module.exports = __webpack_public_path__ + "static/media/UG_Syllabus_2025-26_EXTC_Sem_V-VI.5a2ec5d1.pdf";